import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.addEventListener('DOMContentLoaded', () => {
    const sliders = document.querySelectorAll('.hh-bg-slider');

    sliders.forEach((slider) => {
        new Swiper(slider, {
            slidesPerView: 1,
            loop: true,
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            allowTouchMove: false,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            pagination: {
                el: slider.parentNode.querySelector('.hh-pagination'),
                clickable: true,
            },
            navigation: {
                nextEl: slider.parentNode.querySelector('.hh-button-next'),
                prevEl: slider.parentNode.querySelector('.hh-button-prev'),
            },
        });
    });
});
